export default __webpack_public_path__ + "static/media/visionTwo.428fcc65.jpg";